{
    "UserTour_Next": "Weiter",
    "UserTour_Cancel": "Zeigen Sie es mir später",
    "UserTour_Exit": "Tour deaktivieren",
    "NAME": "UserTour"
}